export default {
    name: 'wmic',
    prefix: 'wmic',
    rootStyle: 'wmicRoot',
};
